import styles from './TextTitle.module.css'

function TextTitle({ title }) {
    return (
        <div className={styles.text_title}>
            <h1 className={styles.title}>{title}</h1>
        </div>
    )
}

export default TextTitle;